<template>
<div class='fw-accordion'>
    <div class='fw-accordion__arrow-box h-pointer' :class='{"fw-arrow-box__open" : data.isOpen}' @click='itemOpen(data)'>
        <div class='fw-accordion__title'>
            <div class='h-flex h-flex-center h-width-30 h-mr-20'>
                <img :src='data.image'>
            </div>
            <h2>
                {{ data.title }}
            </h2>
        </div>
        <div class='fw-accordion__name-arrow'>
            <span class='fw-accordion__name'>
                {{ data.name }}
            </span>
            <div class='fw-accordion__arrow-down'>
                <FwIcon
                    class='h-flex-center h-pointer'
                    icon='arrow-bottom'
                    size='14'
                    color='#27DBBD'>
                </FwIcon>
            </div>
        </div>
    </div>
    <transition name='fw-accordion__item'
                @enter='startTransition'
                @after-enter='endTransition'
                @before-leave='startTransition'
                @after-leave='endTransition'>
        <div v-show='data.isOpen' class='fw-accordion__item'>
            <div class='fw-accordion__item-content'>
                <component :is='currentComponent' v-if='currentComponent' :error='error' :loading='loading'></component>
                <div v-else-if='data.content'>
                    {{ data.content }}
                </div>
                <div v-else-if='$slots.default'>
                    <slot name='default'></slot>
                </div>
            </div>
        </div>
    </transition>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

type FwAccordionDataType = {
    id: number,
    title: string,
    content?: string,
    isOpen?: Boolean,
}

@Component
export default class FwAccordion extends Vue {
    @Prop({ type: Object, default: null }) readonly data!: FwAccordionDataType;
    @Prop({ type: Function, default: null }) readonly currentComponent!: any;
    @Prop({ type: Boolean, default: false }) readonly multiply!: boolean;
    @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
    @Prop({ type: String, default: null }) readonly error!: string;

    itemOpen(data: FwAccordionDataType) {
        if (this.multiply) {
            this.$emit('openItem', data.id);
        } else {
            data.isOpen = !data.isOpen;
        }
    }

    startTransition(el:any) {
        el.style.height = el.scrollHeight + 'px';
    }

    endTransition(el:any) {
        el.style.height = '';
    }
};
</script>

<style lang='sass'>
.fw-accordion
    box-sizing: content-box
    padding: 0 35px
    display: flex
    flex-flow: column nowrap
    justify-content: space-between
    align-items: center
    position: relative
    border-radius: 20px
    background-color: #FFFFFF
    box-shadow: 0 30px 11px -17px rgba(33,63,107,0.05)
    margin: 20px 0
    list-style: none
    &__title
        display: flex
        flex-flow: row nowrap
        justify-content: center
        align-items: center
    &__item
        padding: 0
        width: 100%
        &-content
            margin: 0 50px 30px
    &__arrow-box
        width: 100%
        color: #213F6B
        font-weight: bold
        font-size: 18px
        line-height: 23px
        display: flex
        flex-flow: row nowrap
        justify-content: space-between
        align-items: center
        min-height: 90px
        transition: all .3s
        position: relative
    &__name-arrow
        display: flex
        flex-flow: row nowrap
        justify-content: center
        align-items: center
    &__name
        margin: 0
        text-transform: uppercase
        color: rgba($dark-blue, 0.3)
        font-size: 14px
        font-weight: 300
        letter-spacing: 0.3px
        line-height: unset
    &__arrow-down
        margin-left: 20px
        transition: all 0.2s ease-in-out
    .fw-arrow-box__open .fw-accordion__arrow-down
        transform: rotateZ(180deg)
        transform-origin: 50% 50%

    .fw-accordion__item-enter-active,
    .fw-accordion__item-leave-active
        will-change: height
        transition: height 0.2s ease, opacity 0.2s ease-in-out

    .fw-accordion__item-enter,
    .fw-accordion__item-leave-to
        transition: height 0.2s ease
        height: 0 !important
        opacity: 0
</style>
